export class ActionSheets {
    public static readonly DatePickerMobile = 'date-picker-mobile';
}
